module.exports = __webpack_public_path__ + "static/media/word.1173433c.svg";